export type ImageState = {
  imageWidth: number;
  imageHeight: number;
  x: number;
  y: number;
  zoom: number;
};

export type ImagePicker = {
  width: number;
  height: number;
  isReady: boolean;
};

export type ImageCropData = {
  x: number;
  y: number;
  width: number;
  height: number;
  zoom: number;
  naturalHeight: number;
  naturalWidth: number;
};

export type InitialImageSize = {
  containerWidth: number;
  containerHeight: number;
  naturalWidth: number;
  naturalHeight: number;
};

export const FIT = 'fit';
export const FILL = 'fill';
export type Mode = typeof FIT | typeof FILL;

export const FLIP_HORIZONTAL = 'h';
export type FlipMode = typeof FLIP_HORIZONTAL;

export const RANGE_MIN = 1;
export const RANGE_MAX = 5;
export const RANGE_STEP = 0.1;
